module.exports = __webpack_public_path__ + "img/2_245.8d526c8a.png";